export default function consentmanager() {
  const cmpButton = document.querySelector('.ume-show-cmp-overlay');

  if (cmpButton) {
    cmpButton.addEventListener('click', (ev) => {
      ev.preventDefault();

      if (typeof __cmp === "function") {
        __cmp('showScreenAdvanced')
      }
    })
  }
}